import { render, staticRenderFns } from "./RedPacketTablePane.vue?vue&type=template&id=491e8113&scoped=true"
import script from "./RedPacketTablePane.vue?vue&type=script&lang=js"
export * from "./RedPacketTablePane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491e8113",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('491e8113')) {
      api.createRecord('491e8113', component.options)
    } else {
      api.reload('491e8113', component.options)
    }
    module.hot.accept("./RedPacketTablePane.vue?vue&type=template&id=491e8113&scoped=true", function () {
      api.rerender('491e8113', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/red_packet/components/RedPacketTablePane.vue"
export default component.exports